// eslint-disable-next-line no-magic-numbers
const hasSubDomain = (hostname: string): boolean => hostname.split('.').length > 2;

/**
 * Removes top subdomain (if any) from domain name
 *
 * @param {string} hostname
 * @return {string}
 */
export function stripSubdomain(hostname: string): string {
  if (!hasSubDomain(hostname)) {
    return hostname;
  }

  return hostname.slice(hostname.indexOf('.') + 1);
}

/**
 * Formats cookie domain without top subdomain (if any)
 *
 * @param {string} hostname
 * @return {string}
 */
export function formatCookieDomain(hostname: string): string | undefined {
  if (hostname === 'localhost') {
    // eslint-disable-next-line no-undefined
    return undefined;
  }
  return `.${stripSubdomain(hostname)}`;
}
